import React from 'react'
import { ApolloProvider } from '@apollo/client'
import useApolloClient from 'hooks/useApolloClient'

export default function Apollo({ children }) {
  const { client } = useApolloClient()

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
